import './style.css';

export default class PropertyPreview {
    static selector = '.property-preview';

    constructor(block) {
        this.block = block
    }
}
